import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackupConfigureComponent } from './backup-configure/backup-configure.component';
import { ClientConfigComponent } from './client-config.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedPipesModule } from '../shared/pipes/shared-pipes.module';
import { CustomProductComponent } from './custom-product/custom-product.component';
import { ClientConfigRoutingModule } from './client-config-routing.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';



@NgModule({
  declarations: [
    BackupConfigureComponent,
    ClientConfigComponent,
    CustomProductComponent,
  ],
  imports: [
    CommonModule,
    SharedComponentsModule,
    NgSelectModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    SharedPipesModule,
    ClientConfigRoutingModule,
    NgxDatatableModule
  ],
  exports: [
    BackupConfigureComponent,
    ClientConfigComponent
  ]
})
export class ClientConfigModule { }
